<template>
  <!-- eslint-disable vue/no-lone-template -->
  <!-- eslint-disable vue/no-v-html -->
  <div id="modal--otp" class="custom-modal modal-mask">
    <div class="overlay"></div>
    <div class="content-wrapper modal-container">
      <div class="content">
        <!-- <modal class="custom-modal modal-mask" id="modal--otp"> -->
        <div slot="body" style="height: 100%; position: relative">
          <div class="verification-wrap active">
            <div v-show="!isDesktop" class="verification-wrap-header">
              <span class="close-button" @click="closeModalVerifyCode"
                ><img :src="verificationMethod ? '/assets/img/close.svg' : '/assets/img/arrow_left.svg'"
              /></span>
              <p class="title">
                VERIFIKASI
                <span v-show="verificationMethod" style="text-transform: uppercase"
                  >dengan {{ verificationMethod }}</span
                >
              </p>
            </div>
            <div v-show="isDesktop" class="verification-wrap-header">
              <p class="title">
                VERIFIKASI
                <span v-show="verificationMethod" style="text-transform: uppercase"
                  >dengan {{ verificationMethod }}</span
                >
              </p>
              <span
                v-if="$route.name != 'AddProduct'"
                v-show="!verificationMethod"
                class="close-button"
                @click="closeModalVerifyCode"
                ><img src="/assets/img/close.svg"
              /></span>
            </div>
            <div class="verification-wrap-body">
              <template v-if="!verificationMethod">
                <p class="sub-head" v-html="verificationSubHead"></p>
                <div class="verification-methods">
                  <p class="verification-methods-title">Pilih metode verifikasi :</p>
                  <div class="verification-methods-selection method">
                    <!-- <div class="method-whatsapp" @click="selectVerificationMethod('WhatsApp')">
                                        <div class="wrapper">
                                            <img class="icon"
                                                src="/assets/img/ico-whatsapp-new.svg"
                                                loading="lazy"
                                            />
                                            <span class="prefix">Melalui WhatsApp ke nomor</span>
                                            <span class="number"><strong v-html="inForgotPasswordState && 'phone' in forgot ? '+62' + forgot.phone : '+62' + formattedPhoneNumber"></strong></span>
                                        </div>
                                        <img class="chevron" src="/assets/img/chevron_right.svg" />
                                    </div> -->
                    <div class="method-sms" @click="selectVerificationMethod('sms')">
                      <div class="wrapper">
                        <img class="icon" src="/assets/img/smartphone.svg" loading="lazy" />
                        <span>Melalui SMS ke nomor</span>
                        <span class="number"><strong v-html="'+62' + formattedPhoneNumber"></strong></span>
                      </div>
                      <img class="chevron" src="/assets/img/chevron_right.svg" />
                    </div>
                  </div>
                </div>
                <div v-show="emailVerification" class="verification-not-received">
                  <div>Tidak menerima kode melalui WhatsApp dan SMS?</div>
                  <a href="" class="email-link" @click.prevent="selectVerificationMethod('email')"
                    >Verifikasi lewat email</a
                  >
                </div>
              </template>
              <template v-else>
                <div class="head-mobile">
                  <img
                    v-if="verificationMethod === 'WhatsApp'"
                    class="icon"
                    src="/assets/img/ico-whatsapp-new.svg"
                    loading="lazy"
                  />
                  <img
                    v-if="verificationMethod === 'sms'"
                    class="icon"
                    src="/assets/img/smartphone.svg"
                    loading="lazy"
                  />
                  <img v-if="verificationMethod === 'email'" class="icon" src="/assets/img/email.svg" loading="lazy" />
                  <p
                    v-show="verificationMethod === 'email'"
                    :style="{ marginTop: '24px' }"
                    v-html="verificationSubHead"
                  ></p>
                  <p :style="{ marginTop: '20px' }">
                    Kami telah mengirimkan kode verifikasi <br />
                    melalui {{ verificationMethod }} ke
                    <span
                      ><strong>{{
                        verificationMethod !== 'email' ? '+62' + formattedPhoneNumber : userEmail
                      }}</strong></span
                    >
                  </p>
                </div>
                <form class="verification-otp" method="post" @submit.prevent="validateOtp">
                  <p class="otp-title">Masukkan kode verifikasi</p>
                  <template>
                    <div style="display: flex; flex-direction: row; justify-content: center">
                      <otp-input
                        ref="otpInput"
                        input-classes="otp-input"
                        separator=""
                        :num-inputs="6"
                        :should-auto-focus="true"
                        @on-change="otpChange"
                      />
                    </div>
                  </template>
                  <p v-show="otpError" class="otp-error">{{ otpError }}</p>
                  <div class="formaction">
                    <submit-input
                      v-if="showLoader == false"
                      type="submit"
                      value="VERIFIKASI"
                      class="btn-danger"
                      :disabled="!enableVerification"
                    ></submit-input>
                    <loader-spin v-else />
                  </div>
                </form>
                <div class="verification-send-again text-waiting">
                  <p v-if="otpTimeout && verificationMethod !== 'email'">
                    Tunggu <strong>{{ otpTimeout }} detik</strong> sebelum kirim ulang
                  </p>
                  <div v-else>
                    <p style="margin-bottom: 0">Tidak menerima kode verifikasi?</p>
                    <p style="margin-top: 0">
                      <a class="text-link" title="Kirim ulang" href="" @click.prevent.stop="sendOtpAgain()"
                        >Kirim ulang</a
                      >
                      atau
                      <a
                        class="text-link"
                        title="Ganti metode verifikasi"
                        href=""
                        @click.prevent.stop="returnToVerification((method = ''))"
                        >Ganti metode verifikasi</a
                      >
                    </p>
                  </div>
                </div>
                <div class="verification-change-number">
                  <p>
                    <span>Nomor handphone tidak tepat?</span>&nbsp;<a
                      href=""
                      class="text-link"
                      @click.prevent="showChangeNumberModal"
                      >Ubah Nomor</a
                    >
                  </p>
                </div>
              </template>
            </div>
          </div>
          <div v-show="skippable" class="verification-wrap-footer">
            <div v-show="verificationMethod !== 'email'" class="footer">
              <p v-if="!verificationMethod" class="footer-text">
                <a href="" class="footer-link" @click.prevent="updateTypeOfAuth(0)">LEWATI</a>
              </p>
            </div>
          </div>
        </div>
        <!-- </modal> -->
      </div>
    </div>
  </div>
</template>

<script>
const Config = require('~/config/default.env').default;
import errorMessageSwitcher from '@/shared/mixins/ErrorMessageSwitcher';
import submitInput from '@/shared/UIComponents/Inputs/SubmitInput';
import LoaderSpin from '@/shared/UIComponents/LoaderSpin';
export default {
  name: 'modal-otp-code',
  components: {
    OtpInput: () => import('@bachdgvn/vue-otp-input'),
    submitInput,
    LoaderSpin,
  },
  props: {
    userPhoneNumber: {
      required: true,
      type: String,
    },
    skippable: {
      required: false,
      type: Boolean,
      default: true,
    },
    emailVerification: {
      required: false,
      type: Boolean,
      default: true,
    },
    state: {
      required: true,
      type: String,
    },
    scope: {
      required: false,
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isInputPhoneFocus: false,
      verifyCode: '',
      verificationMethod: '',
      otpIntervalFunction: '',
      otpTimeout: 30,
      enableVerification: false,
      otpError: '',
      showLoader: false,
    };
  },
  computed: {
    isModalShowVerifyCode() {
      return this.$store.state.modal.isModalShow.verifyCode;
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    verificationSubHead() {
      return 'Untuk memastikan kelancaran berbelanja dan keamanan akun kamu, kami akan mengirimkan kode verifikasi';
    },
    formattedPhoneNumber() {
      if (this.userPhoneNumber[0] === '0') {
        return this.userPhoneNumber.substring(1, this.userPhoneNumber.length);
      }
      return this.userPhoneNumber;
    },
    otpSendEndpoint() {
      if (this.scope && this.scope === 'forget-password') {
        return 'forget-password';
      }
      return 'otp/code';
    },
    otpSendPayload() {
      const payload = new Object();
      if (this.scope && this.scope === 'forget-password') {
        payload['phone_no'] = this.userPhoneNumber;
      }
      return payload;
    },
    otpVerifyEndpoint() {
      if (this.scope && this.scope === 'forget-password') {
        return 'reset-password';
      }
      return 'otp/verify';
    },
    otpVerifyPayload() {
      const otpInput = this.$refs.otpInput;
      if ('otp' in otpInput && otpInput.otp.length) {
        const otpNumber = +otpInput.otp.join('');
        const payload = {
          code: otpNumber,
        };
        if (this.scope && this.scope === 'forget-password') {
          payload['user_id'] = this.$store.state.userProfile.id;
          payload['new_password'] = this.$parent.newPassword;
        }
        return payload;
      }
      return {};
    },
  },
  watch: {
    verificationMethod(newVal) {
      if (newVal && newVal !== 'email') {
        this.otpCountdown();
      }
    },
  },
  created() {
    console.log('route', this.$route);
  },
  methods: {
    closeModalVerifyCode() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'otpCode' });
    },
    resend() {},
    onBlurInInputPhone() {
      this.isInputPhoneFocus = false;
    },
    onFocusInInputPhone() {
      this.isInputPhoneFocus = true;
    },
    async selectVerificationMethod(method) {
      if (method !== 'email') {
        const sendOtp = await this.sendOtp();
        if (sendOtp) {
          this.verificationMethod = method;
        }
      }
    },
    sendOtp() {
      this.showLoader = true;
      return axios
        .post(`${Config.MS_SOCO_PUBLIC_API_URL}/auth/${this.otpSendEndpoint}`, this.otpSendPayload)
        .then((response) => response.data.success)
        .catch((error) => {
          const err = errorMessageSwitcher(error.response.data.errorCode);
          this.$toasted.global.error(err);
          return false;
        })
        .finally(() => {
          this.showLoader = false;
        });
    },
    otpCountdown() {
      this.otpIntervalFunction = setInterval(() => {
        this.otpTimeout -= 1;
        if (this.otpTimeout === 0) {
          clearInterval(this.otpIntervalFunction);
        }
      }, 1000);
    },
    resetOtpTimeout() {
      clearInterval(this.otpIntervalFunction);
      this.otpTimeout = 30;
    },
    otpChange() {
      const numInputs = this.$refs.otpInput.numInputs;
      const activeInputs = this.$refs.otpInput.otp.filter((e) => e !== '');
      if (activeInputs.length === numInputs) {
        this.enableVerification = true;
      } else {
        this.enableVerification = false;
      }
    },
    returnToVerification(method) {
      if (!method) {
        this.resetOtpTimeout();
      }
      this.verificationMethod = method;
    },
    async sendOtpAgain() {
      await this.sendOtp();
      await this.resetOtpTimeout();
      await this.otpCountdown();
      if (this.verificationMethod) {
        let prefix = this.verificationMethod;
        let suffix = this.verificationMethod;
        if (this.verificationMethod === 'WhatsApp') {
          prefix = 'Kode';
        } else if (this.verificationMethod === 'sms') {
          prefix = 'SMS';
          suffix = 'inbox';
        } else {
          prefix = 'Email';
        }
        this.$toasted.global.show(`${prefix} terkirim, silakan cek ${suffix} kamu`);
      }
    },
    validateOtp() {
      this.showLoader = true;
      axios
        .post(`${Config.MS_SOCO_PUBLIC_API_URL}/auth/${this.otpVerifyEndpoint}`, this.otpVerifyPayload)
        .then((response) => {
          if (response.data.success) {
            // send back success to parent
            setTimeout(() => {
              const userProfile = this.$store.state.userProfile;
              const updatedProfile = Object.assign(userProfile, {
                is_verified_phone: true,
              });
              this.$store.commit('userProfile', updatedProfile);
              this.$store.commit('toggleModalGlobalState', {
                modalName: 'otpCode',
              });
              this.$emit('isDone', true);
              if (this.state == '') {
                this.$router.push('/add-product');
              } else {
                this.$store.dispatch('setModalSearchProduct', true);
              }
            }, 500);
            this.$toasted.global.show('Verifikasi berhasil');
          }
        })
        .catch((error) => {
          let time = 0;
          const err = errorMessageSwitcher(error.response.data.errorCode);
          this.otpError = err;

          const intervalError = setInterval(() => {
            time++;
            if (time === 5) {
              clearInterval(intervalError);
              this.otpError = '';
            }
          }, 1000);
        })
        .finally(() => {
          this.showLoader = false;
        });
    },
    showChangeNumberModal() {
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'changeNumber',
      });
    },
  },
};
</script>
